// src/pages/admin/PostCreate.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import PostEditor from "./PostEditor";
import { createAdminPost } from "../../lib/adminApi";

const initial = {
  title: "",
  excerpt: "",
  content: "<p></p>",

  // ✅ multi categories
  categories: ["humanitarian_impact"],

  // ✅ primary (kept for backend compatibility; PostEditor also syncs this)
  category: "humanitarian_impact",

  author: "",
  image_url: "",
  tags: [],
  is_published: true,
};

const PostCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(initial);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

    if (!form.image_url || !String(form.image_url).trim()) {
      alert("Please upload/select a featured image before creating the post.");
      return;
    }

    setSaving(true);

    try {
      // ✅ normalize categories
      const cats = Array.isArray(form.categories)
        ? form.categories.map((c) => String(c || "").trim()).filter(Boolean)
        : [];

      // ✅ normalize primary category
      const primary =
        (form.category && String(form.category).trim()) ||
        cats[0] ||
        "humanitarian_impact";

      const finalCats = cats.length ? cats : [primary];

      const fd = new FormData();
      fd.append("title", (form.title || "").trim());
      fd.append("excerpt", (form.excerpt || "").trim());
      fd.append("content", (form.content || "<p></p>").trim());

      // ✅ send both
      fd.append("category", primary);
      fd.append("categories_json", JSON.stringify(finalCats));

      fd.append("author", (form.author || "").trim());
      fd.append("image_url", (form.image_url || "").trim());
      fd.append("is_published", String(!!form.is_published));
      fd.append(
        "tags_json",
        JSON.stringify(Array.isArray(form.tags) ? form.tags : [])
      );

      await createAdminPost(fd);
      navigate("/admin/posts", { replace: true });
    } catch (err) {
      alert(err?.message || "Failed to create post");
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout title="Create Blog Post">
      <PostEditor
        form={form}
        setForm={setForm}
        onSubmit={submit}
        loading={saving}
        submitText="Create Post"
      />
    </AdminLayout>
  );
};

export default PostCreate;
